import script from "./Dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./Dialog.vue?vue&type=script&lang=ts&setup=true"

import "./Dialog.vue?vue&type=style&index=0&id=01bc8412&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/klever-front3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01bc8412"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QBtn,QSeparator,QInnerLoading});
